module.exports = __webpack_public_path__ + "assets/img/solar-panels-5-small.116182f2.jpg";